<template>
  <div>
    <cadastro-base
      :salvar="salvar"
    >
      <template slot="conteudo">
        <b-row>
          <b-form-group
            label="Nome da parametrização"
            class="col-5"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Nome"
            >
              <b-form-input
                ref="nomeParametrizacao"
                v-model="form.nome"
                :state="errors.length > 0 ? false :null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="Tipo checklist"
            class="col-2"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Tipo checklist"
            >
              <b-form-select
                v-model="form.tipoProposta"
                :options="[
                  { value: 'constituicao', text: 'Constituição' },
                  { value: 'transferencia', text: 'Transferência' },
                ]"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="Somente filial?"
            class="col-2"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Filial"
            >
              <b-form-select
                v-model="form.somenteFilial"
                :options="[
                  { value: true, text: 'Sim' },
                  { value: false, text: 'Não' },
                ]"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-col
            cols="3"
          >
            <tributacao-select
              ref="tributacaoSelect"
              v-model="form.tipoTributacao"
              :require="true"
              :filtro-adicional="removeTributacaoCadastrada"
              :disabled="form.somenteFilial === undefined || form.tipoProposta === undefined"
              @input="tributacaoSelecionada"
            />
          </b-col>
        </b-row>
        <atividade-checklist-grupo
          v-for="(checklistGrupo, $index) in gruposChecklist"
          :key="checklistGrupo.id > 0 ? checklistGrupo.id : checklistGrupo.code"
          :ref="`grupo${checklistGrupo.id > 0 ? checklistGrupo.id : checklistGrupo.code}`"
          v-model="gruposChecklist[$index]"
          :state="checklistGrupo.state"
          :parametrizacao="gruposChecklist"
          :tributacao-id="tributacaoSelecionadaId"
          @edicao-atual="setEdicaoAtual($event)"
          @changeOrdemAtividade="onChangeAtividadeChecklist($event, $index)"
          @remove="removeChecklistGrupo"
        />
        <div class="add-atividade">
          <a
            class="text-primary grupo-atividade-hover"
            style="cursor:pointer;font-size:12.5px"
            @click.stop="addGrupoAtividade"
          ><span><i class="fas fa-plus-circle" />&nbsp;Adicionar um grupo de checklist por atividade</span></a>
        </div>
      </template>
    </cadastro-base>
  </div>
</template>

<style lang="scss">
.add-atividade {
  margin-top: 1.5rem;
  margin-left: 0.8rem;
}

.grupo-atividade-hover.text-primary:hover {
  color: #1b874a !important;
}
</style>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import api from '@/app-modulo/comercial/parametrizacao-checklist-honorarios/shared/services/api'

export default {
  name: 'ChecklistHonorarios',
  components: {
    CadastroBase,
    ValidationProvider,
    TributacaoSelect: () => import('@/shared/components/tipo-tributacao-select/TipoTributacaoSelect.vue'),
    AtividadeChecklistGrupo: () => import('@/app-modulo/comercial/parametrizacao-checklist-honorarios/shared/components/atividade-checklist/AtividadeChecklistGrupo.vue'),
  },
  data() {
    return {
      required,
      form: {},
      gruposChecklist: [],
      edicaoAtual: {},
      tributacoes: [],
      tributacaoSelecionadaId: 0,
      parametrizacaoId: 0,
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    } else if (this.$route.params.copia) {
      this.carregarCopia(this.$route.params.id)
    }
    api.getTributacoesCadastradasChecklist()
      .then(payload => {
        this.tributacoes = payload.data
      })
  },
  methods: {
    carregar(value) {
      this.parametrizacaoId = value
      api.getChecklistHonorario(value)
        .then(payload => {
          this.form = payload.data
          this.gruposChecklist = [...this.form.atividadesChecklist]
          this.tributacaoSelecionadaId = this.form.tipoTributacao.id
        })
    },
    carregarCopia(id) {
      api.getParametrizacaoChecklistCopia(id)
        .then(payload => {
          this.form = payload.data
          this.gruposChecklist = [...this.form.atividadesChecklist]
        })
    },
    salvar() {
      if (this.cadastroValido()) {
        if (this.state === 'novo') {
          this.form.atividadesChecklist = this.gruposChecklist
          api.salvarParametrizacaoChecklist(this.$route.params.copia !== undefined, this.form)
            .then(() => {
              this.$router.go(-1)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Parametrização checklist honorários cadastrado com sucesso',
                  text: '',
                  icon: 'CheckCircleIcon',
                  variant: 'success',
                },
              })
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: err.response.data.message || err.message,
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                },
              })
              throw err
            })
        } else {
          this.form.atividadesChecklist = this.gruposChecklist
          api.updateParametrizacaoChecklist(this.form.id, this.form)
            .then(() => {
              this.$router.go(-1)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Parametrização checklist honorários atualizado com sucesso',
                  text: '',
                  icon: 'CheckCircleIcon',
                  variant: 'success',
                },
              })
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: err.response.data.message || err.message,
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                },
              })
              throw err
            })
        }
      }
    },
    addGrupoAtividade() {
      if (!this.hasErrors()) {
        const checklist = {
          code: Date.now().toString(36) + Math.random().toString(36).substring(2),
          id: 0,
          state: 'criacao',
        }
        this.gruposChecklist.push(checklist)
        this.mudarEdicaoAtual(checklist)
      }
    },
    hasErrors() {
      if (!this.form.nome) {
        this.$refs.nomeParametrizacao.focus()
        return true
      }

      if (!this.form.tipoTributacao) {
        this.$refs.tributacaoSelect.$refs.tipoTributacaoSelect.$refs.selectBaseSelect.$refs.search.focus()
        return true
      }

      const grupoChecklist = this.gruposChecklist.find(fin => !fin.tipoAtividade)
      if (grupoChecklist) {
        this.$refs[`grupo${grupoChecklist.id > 0 ? grupoChecklist.id : grupoChecklist.code}`][0].focusAtividadeSelect()
        return true
      }

      return false
    },
    removeChecklistGrupo(value) {
      this.gruposChecklist = this.gruposChecklist.filter(fil => (fil.id > 0 && fil.id !== value.id) || (fil.code && fil.code !== value.code))
    },
    setEdicaoAtual(edicao) {
      this.mudarEdicaoAtual(edicao)
    },
    mudarEdicaoAtual(obj) {
      if (this.edicaoAtual) {
        this.edicaoAtual.state = 'visualizacao'
      }
      this.edicaoAtual = obj
    },
    cadastroValido() {
      const itemGrupo = this.gruposChecklist.find(fin => fin.itensChecklist === undefined || fin.itensChecklist.length === 0 || (fin.itensChecklist.length > 0
      && fin.itensChecklist.find(f => (!f.descricao || f.descricao === '') && f.tipoRegra)))
      if (itemGrupo) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Para salvar o cadastro, todos os grupos deve ter um item cadastrado com uma pergunta',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
        return false
      }
      const regraIndex = this.gruposChecklist.some(fin => fin.itensChecklist.length > 0 && fin.itensChecklist.some(this.existeItemSemRegra))
      if (regraIndex) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Para salvar o cadastro, todos os itens precisam ter uma regra cadastrada',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
        return false
      }

      if (this.gruposChecklist && this.gruposChecklist.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Para salvar o cadastro, deve haver pelo menos um grupo parametrizado com uma pergunta',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
        return false
      }
      return true
    },
    existeItemSemRegra(element) {
      if (!element.tipoRegra && (element.descricao && element.descricao !== '')) {
        return true
      }
      return false
    },
    removeTributacaoCadastrada(tributacao) {
      if (this.tributacoes.length > 0) {
        const tributacoesPossiveis = tributacao.filter(fil => !this.tributacoes.find(fin => (fin.nome === fil.nome && fin.qtdUtilizadoConstituicao + fin.qtdUtilizadoTransferencia >= 4)
        || (fin.nome === fil.nome && (this.form.tipoProposta === 'constituicao'
          ? !(fin.qtdUtilizadoConstituicao < 2 && (fin.somenteFilialConstituicao === undefined || fin.somenteFilialConstituicao !== this.form.somenteFilial))
          : !(fin.qtdUtilizadoTransferencia < 2 && (fin.somenteFilialTransferencia === undefined || fin.somenteFilialTransferencia !== this.form.somenteFilial))))))

        return tributacoesPossiveis
      }
      return null
    },
    tributacaoSelecionada(value) {
      this.tributacaoSelecionadaId = value.id
    },
    onChangeAtividadeChecklist(atividade, grupoIndex) {
      this.gruposChecklist[grupoIndex] = atividade.grupoAtividade
    },
  },
}
</script>
